export default {
      id: "small-user-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "sprite.svg#small-user",
      toString: function () {
        return this.url;
      }
    }